import React from 'react';

import { useStaticQuery, graphql } from 'gatsby'
import * as styles from 'src/uglib_styles/footerMenu.module.css';

function menuButtonClick(event) {
	const button = event.target.closest('button');
	const expanded = button.getAttribute('aria-expanded');
	button.setAttribute('aria-expanded', toggle_boolean_string(expanded));
}

function toggle_boolean_string(value) {
	if (value === "true") {
		return "false";
	}

	return "true"
}

function renderMenu(menuData) {
	const links = menuData.links.nodes.filter(item => item.parent == null);
	const pageSpecificMenu = links.map(item => {	
	
		let submenu = item.children;
		let submenuItems = [];
		
		if (submenu !== null && submenu.length > 0) {
			for (let i=0; i<submenu.length; i++) {
				submenuItems.push(
					<li key={submenu[i].id}>
						<a href={submenu[i].url}>{submenu[i].title}</a>
					</li>
				);
			}
		}

        
		return (<React.Fragment key={item.id}>		
			{submenu !== null && submenu.length > 0 ?  
				<li>
					<uofg-dropdown-menu className={styles.navbar} onClick={menuButtonClick}>
						<button className={styles.button} data-for="menu-button" aria-expanded="false">{item.title}<span className="fa-solid fa-chevron-down"></span></button>
						
						<ul className={styles.submenu} data-for="menu-content">
							{submenuItems}
						</ul>
					</uofg-dropdown-menu>
				</li>
			: <React.Fragment key={item.id}><li><a href={item.url}>{item.title}</a></li></React.Fragment>}

		</React.Fragment>)
	});

	return pageSpecificMenu;
}

function FooterMenu() {
    const footerMenuData = useStaticQuery(graphql`
		query FooterLinkQuery {
			links: allMenuItems(filter: {menu_name: {eq: "dlc-footer"}}, sort: {weight: ASC}) {
				nodes {
					title
					url
					menu_name
					children {
						id
						... on MenuItems {
							id
							title
							url
							weight
							menu_name
						}
					}
					id
					parent {
						... on MenuItems {
							id
							title
							url
						}
					}
				}
			}
		}
	`)

    let renderedFooterMenu = <div className={styles.footer_nav_wrapper}>
        <nav>
			<ul id={styles.footer_nav}>
				{renderMenu(footerMenuData)}
			</ul>
		</nav>
    </div>

    return renderedFooterMenu;
}

export default FooterMenu
